import _createForOfIteratorHelper from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { isEnglishDigits } from "../../../helpers/Functions";
import SocialsData from "./SocialsData.json";
export default {
  name: "Socials.vue",
  data: function data() {
    var _this = this;

    var socials = _toConsumableArray(SocialsData);

    socials.forEach(function (item, index) {
      var _this$socialsData;

      (_this$socialsData = _this.socialsData) === null || _this$socialsData === void 0 ? void 0 : _this$socialsData.forEach(function (element) {
        if (item.id === element.id) {
          socials[index] = _objectSpread({}, element);
        } else if (!element.id) {
          socials[0] = _objectSpread(_objectSpread({}, socials[0]), {}, {
            url: element.split("com/")[1]
          });
        }
      });
    });
    return {
      socials: socials
    };
  },
  methods: {
    getSocialMedias: function getSocialMedias() {
      var _iterator = _createForOfIteratorHelper(this.socials),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (isEnglishDigits.test(item.url)) {
            this.$vs.notify({
              text: "".concat(item.label, " \u0628\u0627\u06CC\u062F \u0634\u0627\u0645\u0644 \u0644\u06CC\u0646\u06A9 \u0628\u0627\u0634\u062F."),
              color: "danger",
              position: "bottom-center"
            });
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.socials.filter(function (item) {
        return item.url !== "";
      }).map(function (item) {
        var _item$url;

        return _objectSpread(_objectSpread({}, item), {}, {
          url: (_item$url = item.url) === null || _item$url === void 0 ? void 0 : _item$url.replace(/^https?:\/\//, "").toLowerCase()
        });
      });
    }
  },
  props: {
    socialsData: {
      type: Array,
      required: false
    }
  }
};